module.exports = __webpack_public_path__ + "img/Shipping.5c12796b.svg";